import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=7930edba&scoped=true&lang=pug"
import script from "./layout-default.vue?vue&type=script&lang=ts"
export * from "./layout-default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7930edba",
  null
  
)

export default component.exports